import ReactGA from 'react-ga';
import React from 'react'
import { Table, Row, Col, Divider } from 'antd'
import * as COLUMNS from './columns.js'

class Outline extends React.Component {
  constructor() {
    super();
    this.state = {
      user: null,
      QualityPlans: []
    };
  }
  componentDidMount() {
    ReactGA.pageview('/outline');

  }

  render() {
    const { user } = this.props;
    let data = [];
    let dataCompleted = [];
    let dataInprogress = [];
    let dataUpcoming = [];
    let dataAwaitingPayment = [];

    var twoMonth = new Date();
    twoMonth.setDate(twoMonth.getDate() - 60);
    var twoMonthInput = twoMonth.toISOString();

    if (this.props.QualityPlans && user !== null) {
      for (var i = 0; i < this.props.QualityPlans.length; i++) {
        if (this.props.user.role === 'admin') {
          if (this.props.QualityPlans[i].form_values.b059) {
            var drilltecJobNumber = this.props.QualityPlans[i].form_values.b059;
          } else if (this.props.QualityPlans[i].form_values.c713) {
            drilltecJobNumber = this.props.QualityPlans[i].form_values.c713
          } else {
            drilltecJobNumber = ''
          }
          data.push({ jobNumber: drilltecJobNumber, record: this.props.QualityPlans[i] })
          if (this.props.QualityPlans[i].client_created_at.slice(0, -10) >= twoMonthInput) {
            if (this.props.QualityPlans[i].status === 'Completed') {
              dataCompleted.push({
                bore: drilltecJobNumber,
                client: this.props.QualityPlans[i].form_values["6f71"]
              })
            }
            if (this.props.QualityPlans[i].status === 'In Progress') {
              dataInprogress.push({
                bore: drilltecJobNumber,
                client: this.props.QualityPlans[i].form_values["6f71"]
              })
            }
            if (this.props.QualityPlans[i].status === 'Upcoming') {
              dataUpcoming.push({
                bore: drilltecJobNumber,
                client: this.props.QualityPlans[i].form_values["6f71"]
              })
            }
            if (this.props.QualityPlans[i].status === 'Awaiting Invoice') {
              dataAwaitingPayment.push({
                bore: drilltecJobNumber,
                client: this.props.QualityPlans[i].form_values["6f71"]
              })
            }
          }
        }
        else if (this.props.user.role === 'client') {
          if (this.props.QualityPlans[i].form_values["6f71"] === this.props.user.username) {
            if (this.props.QualityPlans[i].form_values.b059) {
              drilltecJobNumber = this.props.QualityPlans[i].form_values.b059;
            } else if (this.props.QualityPlans[i].form_values.c713) {
              drilltecJobNumber = this.props.QualityPlans[i].form_values.c713
            } else {
              drilltecJobNumber = ''
            }
            data.push({ jobNumber: drilltecJobNumber, record: this.props.QualityPlans[i] })
            if (this.props.QualityPlans[i].client_created_at.slice(0, -10) >= twoMonthInput) {
              if (this.props.QualityPlans[i].status === 'Completed') {
                dataCompleted.push({
                  bore: drilltecJobNumber,
                  client: this.props.QualityPlans[i].form_values['72a2']
                })
              }
              if (this.props.QualityPlans[i].status === 'In Progress') {
                dataInprogress.push({
                  bore: drilltecJobNumber,
                  client: this.props.QualityPlans[i].form_values['72a2']
                })
              }
              if (this.props.QualityPlans[i].status === 'Upcoming') {
                dataUpcoming.push({
                  bore: drilltecJobNumber,
                  client: this.props.QualityPlans[i].form_values['72a2']
                })
              }
              if (this.props.QualityPlans[i].status === 'Awaiting Invoice') {
                dataAwaitingPayment.push({
                  bore: drilltecJobNumber,
                  client: this.props.QualityPlans[i].form_values['72a2']
                })
              }
            }
          }
        }
      }
      function compare(a, b) {
        if (a.jobNumber < b.jobNumber)
          return -1;
        if (a.jobNumber > b.jobNumber)
          return 1;
        return 0;
      }

      data.sort(compare);
      data.reverse();
    }

    return (
      <div>
        <Row gutter={12}>
          <h1>Recent Status breakup</h1>
          <h4 style={{ paddingBottom: 10 }}>This information is relevant to records created or updated in the last 60 days.</h4>
          <Col lg={6} sm={12} xs={24} className='outlineStats'>
            <Table id='tableResizer' bordered pagination={false}
              columns={COLUMNS.completed}
              dataSource={dataCompleted}
            />
          </Col>
          <Col lg={6} sm={12} xs={24} className='outlineStats'>
            <Table id='tableResizer' bordered pagination={false}
              columns={COLUMNS.inProgress}
              dataSource={dataInprogress}
            />
          </Col>
          <Col lg={6} sm={12} xs={24} className='outlineStats'>
            <Table id='tableResizer' bordered pagination={false}
              columns={COLUMNS.upcoming}
              dataSource={dataUpcoming}
            />
          </Col>
          <Col lg={6} sm={12} xs={24} className='outlineStats'>
            <Table id='tableResizer' bordered pagination={false}
              columns={COLUMNS.awaitingPayment}
              dataSource={dataAwaitingPayment}
            />
          </Col>
        </Row>
        <Divider />
        <Row>
          <Col>
            <h1>All Jobs</h1>
            <h4 style={{ paddingBottom: 10 }}>A brief overview of all bores completed, in progress or upcoming.</h4>
            <Table
              id='tableResizer'
              bordered
              columns={COLUMNS.outline}
              dataSource={data}
              rowKey='[1]id'
            />
          </Col>
        </Row>
      </div>
    )
  }
}

export default Outline;